import angular from 'angular';
import caseReferenceComponent from './case-reference.component';

export default angular.module('components.app.adverseEvent.case-reference', [])
  .component('caseReference', caseReferenceComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/case-reference/case-reference.module.js